import { JsonExportUtils, XlsxExportUtils } from "@stellar/utils";

/** The file formats a table can be exported to, in the order they are offered to the user */
export const EXPORT_FORMATS = ["excel", "json"] as const;

/** A file format a table can be exported to */
export type ExportFormat = (typeof EXPORT_FORMATS)[number];

/** The labels of the export formats, as shown to the user */
export const EXPORT_FORMAT_LABELS: Record<ExportFormat, string> = {
  excel: "Excel (.xlsx)",
  json: "JSON (.json)",
};

/** A row of an exported file, keyed by the column header */
export type ExportRow = JsonExportUtils.ExportableRecord;

interface ExportRowsParams {
  /** The rows to export. The keys of the first row become the column headers */
  rows: ExportRow[];

  /** Name of the file, without extension */
  fileName: string;

  /** The format of the file */
  format: ExportFormat;
}

/** Downloads the rows as a file of the given format. Nothing is downloaded when there are no rows */
export async function exportRows({
  rows,
  fileName,
  format,
}: ExportRowsParams): Promise<void> {
  if (format === "excel") {
    await XlsxExportUtils.convertFileToXlsx({ data: rows, fileName });
    return;
  }

  JsonExportUtils.exportData({ data: rows, fileName });
}
